/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import FormField, {
  FormTextFieldProps
} from '../../../../client/js/components/form/fields/FormField'

function UsernameField (props: FormTextFieldProps) {
  const { name = 'username', ...others } = props
  const intl = useIntl()
  return (
    <FormField
      label={intl.formatMessage({
        id: 'username',
        defaultMessage: 'Nom d\'utilisateur'
      })}
      name={name}
      {...others}
    />
  )
}

export default UsernameField
